import { ModelTypes } from '@zeus';
import { bindable } from "aurelia";

export class IntegrationCardSoonComponent {
  @bindable integration: ModelTypes["AppIntegration"]
}